import { Fragment } from 'react';
import { toHighlightSegments } from '@/utils/listSearch';

interface HighlightTextProps {
  text: string;
  highlightedText: string | undefined;
}

export function HighlightText({ text, highlightedText }: HighlightTextProps) {
  if (!highlightedText) return <>{text}</>;

  return (
    <>
      {toHighlightSegments(text, highlightedText).map((segment) =>
        segment.isMatch ? (
          <mark key={segment.start} className="bg-highlight text-highlight-foreground">
            {segment.text}
          </mark>
        ) : (
          <Fragment key={segment.start}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
